export enum OfferNotificationVariant {
    OFFER,
    LIST
}
export enum OfferNotificationVariant {
    OFFER,
    LIST
}
